<template>
  <v-app id="app">
    <Banner />
    <Header />
    <v-main class="pb-0">
      <!-- Provides the application the proper gutter -->
      <Flash v-if="error.message" :message="error.message" :type="error.type" />
      <LoadingOverlay />
      <router-view />
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Flash from '@/components/Flash';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import LoadingOverlay from '@/components/LoadingOverlay';
import Banner from './components/banner';
import { MAIN_PAGE_META } from './consts/metaTags';

export default {
  name: 'App',
  metaInfo() {
    return MAIN_PAGE_META;
  },
  computed: {
    error() {
      return this.$store.state.error;
    },

    user() {
      return this.$store.getters.userInfo;
    }
  },
  components: { Banner, Flash, Header, Footer, LoadingOverlay },
  created() {
    this.axiosInterceptors();
    this.checkToken();
    this.fetchProfile();
    //this.displayPopup();
  },
  updated() {
    this.checkToken();
    this.fetchProfile();
  },
  methods: {
    //displayPopup() {
    //  const lookupAPI = process.env.IP_LOOKUP_URL;
    //  this.$http.get(lookupAPI).then(res => {
    //    const result = res.data;
    //    if (result.country_code.toLowerCase() !== 'ca') {
    //      internationalPopup('show');
    //    }
    //    //else if (result.country_code.toLowerCase() === 'ca') {
    //    //  const isShown = localStorage.getItem('discountPopup');
    //    //  if (!isShown) {
    //    //    localStorage.setItem('discountPopup', 'shown');
    //    //    discountPopup('show');
    //    //  }
    //    //}
    //  });
    //},
    checkToken() {
      let currentTime = this.$datetime.getCurrentTimeInMillisec();

      if (
        !this.$validator.isEmpty(this.user.lastLogin) &&
        currentTime - this.user.lastLogin > 86400000
      ) {
        this.$router.push({ name: 'Logout' });
      }

      if (!localStorage.token && this.$route.path === '/kids') {
        this.$router.push('/login?redirect=' + this.$route.path);
      }
    },

    fetchProfile() {
      if (localStorage.token) {
        this.$http
          .get('/profile')
          .then(response => {
            //TODO think about using actions instead of directly committing
            //https://vuex.vuejs.org/guide/actions.html
            this.$sessionUser._updateUserInfo(
              this.$formatter.extend(this.user, response.data.profile)
            );
            this.$store.commit('setUserInfo', response.data.profile);

            //Note: wishes are fetched and updated here.
            this.$store.commit('addWishes', response.data.wishes);
          })
          .catch(() => {
            console.log('failed to retrieve profile');
          });
      }
    },

    axiosInterceptors() {
      this.$http.interceptors.request.use(
        config => {
          if (localStorage.token) {
            config.headers.authorization = `Bearer ${localStorage.token}`;
          }
          return config;
        },
        error => {
          Promise.reject(error);
        }
      );

      this.$http.interceptors.response.use(
        response => {
          return response;
        },
        error => {
          //Redirect on error from the API
          if (error.response.status === 500) {
            this.$router.push('/oops');
          }

          return Promise.reject(error);
        }
      );
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/general.scss';
@import 'vue-phone-number-input/dist/vue-phone-number-input.css';
</style>



// WEBPACK FOOTER //
// src/App.vue